import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
    card: {
        backgroundColor: "#303030",
    },
    centerText: {
        textAlign: "center"
    }
});